import { render, staticRenderFns } from "./usersForm.vue?vue&type=template&id=645f5ff3&scoped=true&"
import script from "./usersForm.vue?vue&type=script&lang=js&"
export * from "./usersForm.vue?vue&type=script&lang=js&"
import style0 from "./usersForm.vue?vue&type=style&index=0&id=645f5ff3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645f5ff3",
  null
  
)

export default component.exports